/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

$(document).ready(function () {
    function ScrollExecute() {
        scrollNode = $("#more").last();
        scrollURL = $("#more a").last().attr("href");
        if (scrollNode.length > 0 && scrollNode.css("display") != "none") {
            $.ajax({
                type: "GET",
                url: scrollURL,
                beforeSend: function () {
                    scrollNode.remove();
                    $(".spinner-wrapper").show();
                    // Add loading spinner
                },
                success: function (data) {
                    // remove loading feedback
                    $(".spinner-wrapper").hide();
                    // scrollNode.next().remove();
                    var filteredData = $(data).find(
                        ".product-facet__product-list"
                    );
                    var nextMore = $(data).find("#more");
                    filteredData.insertBefore($("#product-list-foot"));
                    nextMore.insertAfter($("#product-list-foot"));
                    console.log("unslick");
                    console.log($(".product-grid__related-items"));

                    $(".product-grid__related-items")
                        .not(".slick-initialized")
                        .slick({
                            infinite: true,
                            slidesToShow: 3,
                            slidesToScroll: 3,
                            arrows: true,
                            prevArrow:
                                '<svg class="slick-prev slick-arrow" version="1.1" width="6px" height="10px" viewBox="0 0 6.0 10.0" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><clipPath id="10711812254105122484848114"><path d="M1440,0 L1440,4163 L0,4163 L0,0 L1440,0 Z"></path></clipPath><clipPath id="10211211095104501019510698"><path d="M1.21643646,0.180481732 L5.68569211,4.27665462 C5.88526556,4.45959898 5.99974686,4.72306582 6,5 C6.00032762,5.27635063 5.88638723,5.53946082 5.68729572,5.72209247 L1.21643646,9.81951827 C0.908306794,10.0888639 0.450122998,10.0526965 0.184470821,9.7380586 C-0.0811813567,9.4234207 -0.0571322892,8.9453998 0.238636445,8.66141392 L4.14823289,5.07851555 C4.16994364,5.05869072 4.18239344,5.03007575 4.18239344,5 C4.18239344,4.96992425 4.16994364,4.94130928 4.14823289,4.92148445 L0.238636445,1.33858608 C-0.0571322892,1.0546002 -0.0811813567,0.576579296 0.184470821,0.261941397 C0.450122998,-0.0526965009 0.908306794,-0.0888638862 1.21643646,0.180481732 Z"></path></clipPath></defs><g transform="translate(-623.0 -2203.0)"><g clip-path="url(#10711812254105122484848114)"><g transform="translate(623.0 2193.0)"><g transform="translate(6.0 10.0) scale(-1.0 1.0)"><g clip-path="url(#10211211095104501019510698)"><polygon points="1.11022302e-16,-5.55111512e-17 6.0000007,-5.55111512e-17 6.0000007,10 1.11022302e-16,10 1.11022302e-16,-5.55111512e-17" stroke="none" fill="#000000"></polygon></g></g></g></g></g></svg>',
                            nextArrow:
                                '<svg class="slick-next slick-arrow" version="1.1" width="6px" height="10px" viewBox="0 0 6.0 10.0" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><clipPath id="515397118108106112118103116"><path d="M1440,0 L1440,4163 L0,4163 L0,0 L1440,0 Z"></path></clipPath><clipPath id="501171015449121110480110"><path d="M1.21643646,0.180481732 L5.68569211,4.27665462 C5.88526556,4.45959898 5.99974686,4.72306582 6,5 C6.00032762,5.27635063 5.88638723,5.53946082 5.68729572,5.72209247 L1.21643646,9.81951827 C0.908306794,10.0888639 0.450122998,10.0526965 0.184470821,9.7380586 C-0.0811813567,9.4234207 -0.0571322892,8.9453998 0.238636445,8.66141392 L4.14823289,5.07851555 C4.16994364,5.05869072 4.18239344,5.03007575 4.18239344,5 C4.18239344,4.96992425 4.16994364,4.94130928 4.14823289,4.92148445 L0.238636445,1.33858608 C-0.0571322892,1.0546002 -0.0811813567,0.576579296 0.184470821,0.261941397 C0.450122998,-0.0526965009 0.908306794,-0.0888638862 1.21643646,0.180481732 Z"></path></clipPath></defs><g transform="translate(-811.0 -2203.0)"><g clip-path="url(#515397118108106112118103116)"><g transform="translate(623.0 2193.0)"><g transform="translate(188.0 10.0)"><g clip-path="url(#501171015449121110480110)"><polygon points="1.11022302e-16,-5.55111512e-17 6.0000007,-5.55111512e-17 6.0000007,10 1.11022302e-16,10 1.11022302e-16,-5.55111512e-17" stroke="none" fill="#000000"></polygon></g></g></g></g></g></svg>',
                        });
                },
                dataType: "html",
            });
        }
    }

    // Infinite scroll
    $(document).on("click touch", "#more a", function (e) {
        e.preventDefault();
        ScrollExecute();
    });

    // Thumbs slides
    $(".product-grid__related-items").slick({
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 3,
        arrows: true,
        prevArrow:
            '<svg class="slick-prev slick-arrow" version="1.1" width="6px" height="10px" viewBox="0 0 6.0 10.0" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><clipPath id="10711812254105122484848114"><path d="M1440,0 L1440,4163 L0,4163 L0,0 L1440,0 Z"></path></clipPath><clipPath id="10211211095104501019510698"><path d="M1.21643646,0.180481732 L5.68569211,4.27665462 C5.88526556,4.45959898 5.99974686,4.72306582 6,5 C6.00032762,5.27635063 5.88638723,5.53946082 5.68729572,5.72209247 L1.21643646,9.81951827 C0.908306794,10.0888639 0.450122998,10.0526965 0.184470821,9.7380586 C-0.0811813567,9.4234207 -0.0571322892,8.9453998 0.238636445,8.66141392 L4.14823289,5.07851555 C4.16994364,5.05869072 4.18239344,5.03007575 4.18239344,5 C4.18239344,4.96992425 4.16994364,4.94130928 4.14823289,4.92148445 L0.238636445,1.33858608 C-0.0571322892,1.0546002 -0.0811813567,0.576579296 0.184470821,0.261941397 C0.450122998,-0.0526965009 0.908306794,-0.0888638862 1.21643646,0.180481732 Z"></path></clipPath></defs><g transform="translate(-623.0 -2203.0)"><g clip-path="url(#10711812254105122484848114)"><g transform="translate(623.0 2193.0)"><g transform="translate(6.0 10.0) scale(-1.0 1.0)"><g clip-path="url(#10211211095104501019510698)"><polygon points="1.11022302e-16,-5.55111512e-17 6.0000007,-5.55111512e-17 6.0000007,10 1.11022302e-16,10 1.11022302e-16,-5.55111512e-17" stroke="none" fill="#000000"></polygon></g></g></g></g></g></svg>',
        nextArrow:
            '<svg class="slick-next slick-arrow" version="1.1" width="6px" height="10px" viewBox="0 0 6.0 10.0" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><clipPath id="515397118108106112118103116"><path d="M1440,0 L1440,4163 L0,4163 L0,0 L1440,0 Z"></path></clipPath><clipPath id="501171015449121110480110"><path d="M1.21643646,0.180481732 L5.68569211,4.27665462 C5.88526556,4.45959898 5.99974686,4.72306582 6,5 C6.00032762,5.27635063 5.88638723,5.53946082 5.68729572,5.72209247 L1.21643646,9.81951827 C0.908306794,10.0888639 0.450122998,10.0526965 0.184470821,9.7380586 C-0.0811813567,9.4234207 -0.0571322892,8.9453998 0.238636445,8.66141392 L4.14823289,5.07851555 C4.16994364,5.05869072 4.18239344,5.03007575 4.18239344,5 C4.18239344,4.96992425 4.16994364,4.94130928 4.14823289,4.92148445 L0.238636445,1.33858608 C-0.0571322892,1.0546002 -0.0811813567,0.576579296 0.184470821,0.261941397 C0.450122998,-0.0526965009 0.908306794,-0.0888638862 1.21643646,0.180481732 Z"></path></clipPath></defs><g transform="translate(-811.0 -2203.0)"><g clip-path="url(#515397118108106112118103116)"><g transform="translate(623.0 2193.0)"><g transform="translate(188.0 10.0)"><g clip-path="url(#501171015449121110480110)"><polygon points="1.11022302e-16,-5.55111512e-17 6.0000007,-5.55111512e-17 6.0000007,10 1.11022302e-16,10 1.11022302e-16,-5.55111512e-17" stroke="none" fill="#000000"></polygon></g></g></g></g></g></svg>',
    });

    $("body").on("click touch", ".product-grid__related-items a", function (e) {
        e.preventDefault();
        var title = $(this).data("title");
        var price = $(this).data("price");
        var image = $(this).data("image");
        var secondaryImage = $(this).data("secondary-image");
        var url = $(this).data("url");
        var id = $(this).data("id");
        var eco = $(this).data("eco");
        var labels = $(this).data("labels");

        if (eco == true) {
            $(this).closest(".product-item").find(".eco-badge").removeClass("hidden");
        } else {
            $(this).closest(".product-item").find(".eco-badge").addClass("hidden");
        }

        $(this).closest(".product-item").find(".label-list").remove();
        // $(this).closest(".product-item").find("form").css("opacity", 0);
        // $(this).closest(".product-item").find("form").css("z-index", -1);

        if (labels) {
            labels = labels.split(",");

            // Create label list container
            const labelListHtml = `
                <div class="product-item__label-list label-list">
                    ${labels.map(label => `<span class="label label--custom">${label}</span>`).join('')}
                </div>
            `;

            $(this).closest(".product-item").find(".product-item__image-wrapper").append(labelListHtml);
        }

        $(this).closest(".product-item").find("[name='id']").val(id);

        $(this)
            .closest(".product-item")
            .find(".product-item-meta__title")
            .attr("href", url);
        $(this)
            .closest(".product-item")
            .find(".product-item__aspect-ratio")
            .attr("href", url);

        $(this)
            .closest(".product-item")
            .find(".current")
            .removeClass("current");

        $(this).parent().addClass("current");

        $(this)
            .closest(".product-item")
            .find(".product-item-meta__title")
            .text(title);
        $(this).closest(".product-item").find(".price").text(price);
        $(this)
            .closest(".product-item")
            .find(".product-item__primary-image")
            .attr("srcset", image);

        // Update secondary image if it exists
        if (secondaryImage) {
            $(this)
                .closest(".product-item")
                .find(".product-item__secondary-image")
                .attr("srcset", secondaryImage);
        }
    });

    // Mobile swipe for product images - Add CSS for indicators
    if (!document.getElementById('swipe-indicators-css')) {
        const style = document.createElement('style');
        style.id = 'swipe-indicators-css';
        style.textContent = `
            .product-item__swipe-indicators {
                position: absolute;
                bottom: 8px;
                left: 50%;
                transform: translateX(-50%);
                display: flex;
                gap: 6px;
                z-index: 2;
                opacity: 0.8;
            }
            .swipe-dot {
                width: 6px;
                height: 6px;
                border-radius: 50%;
                background: rgba(0, 0, 0, 0.5);
                transition: all 0.3s ease;
                cursor: pointer;
            }
            .swipe-dot.active {
                background: rgba(0, 0, 0, 0.9);
                transform: scale(1.2);
            }
            @media (min-width: 768px) {
                .product-item__swipe-indicators {
                    display: none;
                }
            }
        `;
        document.head.appendChild(style);
    }

    let startX = 0;

    $("body").on("touchstart", ".product-item__aspect-ratio", function (e) {
        startX = e.originalEvent.touches[0].clientX;
    });

    $("body").on("touchend", ".product-item__aspect-ratio", function (e) {
        if (!startX) return;

        const endX = e.originalEvent.changedTouches[0].clientX;
        const diffX = startX - endX;
        const threshold = 50; // minimum swipe distance

        if (Math.abs(diffX) > threshold) {
            const $container = $(this);
            const $primaryImg = $container.find(".product-item__primary-image").not("[hidden]");
            const $secondaryImg = $container.find(".product-item__secondary-image");

            // Get current state from container data attribute
            let currentImageIndex = parseInt($container.data('current-image') || '0');

            if ($secondaryImg.length > 0) {
                // Setup secondary image for smooth transitions
                $secondaryImg.css({
                    'display': 'block',
                    'visibility': 'visible',
                    'position': 'absolute',
                    'top': '0',
                    'left': '0',
                    'width': '100%',
                    'height': '100%',
                    'object-fit': 'cover',
                    'z-index': '1'
                });

                if (diffX > 0) {
                    // Swipe left - show secondary
                    if (currentImageIndex === 0) {
                        $secondaryImg.css({
                            'transform': 'translateX(100%)',
                            'opacity': '0',
                            'transition': 'none'
                        });

                        // Trigger reflow then animate
                        $secondaryImg[0].offsetHeight;

                        $secondaryImg.css({
                            'opacity': '1',
                            'transform': 'translateX(0)',
                            'transition': 'all 0.3s ease'
                        });
                        $primaryImg.css({
                            'opacity': '0',
                            'transform': 'translateX(-100%)',
                            'transition': 'all 0.3s ease'
                        });
                        $container.data('current-image', '1');

                        // Update indicators
                        $container.find('.swipe-dot').removeClass('active');
                        $container.find('.swipe-dot:nth-child(2)').addClass('active');
                    }
                } else {
                    // Swipe right - show primary
                    if (currentImageIndex === 1) {
                        $primaryImg.css({
                            'opacity': '1',
                            'transform': 'translateX(0)',
                            'transition': 'all 0.3s ease'
                        });
                        $secondaryImg.css({
                            'opacity': '0',
                            'transform': 'translateX(100%)',
                            'transition': 'all 0.3s ease'
                        });
                        $container.data('current-image', '0');

                        // Update indicators
                        $container.find('.swipe-dot').removeClass('active');
                        $container.find('.swipe-dot:nth-child(1)').addClass('active');
                    }
                }
            }
        }

        startX = 0;
    });

    // Thumbs in product page

    $(".product__related-items").slick({
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 4,
        arrows: true,
        prevArrow:
            '<svg class="slick-prev slick-arrow" version="1.1" width="6px" height="10px" viewBox="0 0 6.0 10.0" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><clipPath id="10711812254105122484848114"><path d="M1440,0 L1440,4163 L0,4163 L0,0 L1440,0 Z"></path></clipPath><clipPath id="10211211095104501019510698"><path d="M1.21643646,0.180481732 L5.68569211,4.27665462 C5.88526556,4.45959898 5.99974686,4.72306582 6,5 C6.00032762,5.27635063 5.88638723,5.53946082 5.68729572,5.72209247 L1.21643646,9.81951827 C0.908306794,10.0888639 0.450122998,10.0526965 0.184470821,9.7380586 C-0.0811813567,9.4234207 -0.0571322892,8.9453998 0.238636445,8.66141392 L4.14823289,5.07851555 C4.16994364,5.05869072 4.18239344,5.03007575 4.18239344,5 C4.18239344,4.96992425 4.16994364,4.94130928 4.14823289,4.92148445 L0.238636445,1.33858608 C-0.0571322892,1.0546002 -0.0811813567,0.576579296 0.184470821,0.261941397 C0.450122998,-0.0526965009 0.908306794,-0.0888638862 1.21643646,0.180481732 Z"></path></clipPath></defs><g transform="translate(-623.0 -2203.0)"><g clip-path="url(#10711812254105122484848114)"><g transform="translate(623.0 2193.0)"><g transform="translate(6.0 10.0) scale(-1.0 1.0)"><g clip-path="url(#10211211095104501019510698)"><polygon points="1.11022302e-16,-5.55111512e-17 6.0000007,-5.55111512e-17 6.0000007,10 1.11022302e-16,10 1.11022302e-16,-5.55111512e-17" stroke="none" fill="#000000"></polygon></g></g></g></g></g></svg>',
        nextArrow:
            '<svg class="slick-next slick-arrow" version="1.1" width="6px" height="10px" viewBox="0 0 6.0 10.0" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><clipPath id="515397118108106112118103116"><path d="M1440,0 L1440,4163 L0,4163 L0,0 L1440,0 Z"></path></clipPath><clipPath id="501171015449121110480110"><path d="M1.21643646,0.180481732 L5.68569211,4.27665462 C5.88526556,4.45959898 5.99974686,4.72306582 6,5 C6.00032762,5.27635063 5.88638723,5.53946082 5.68729572,5.72209247 L1.21643646,9.81951827 C0.908306794,10.0888639 0.450122998,10.0526965 0.184470821,9.7380586 C-0.0811813567,9.4234207 -0.0571322892,8.9453998 0.238636445,8.66141392 L4.14823289,5.07851555 C4.16994364,5.05869072 4.18239344,5.03007575 4.18239344,5 C4.18239344,4.96992425 4.16994364,4.94130928 4.14823289,4.92148445 L0.238636445,1.33858608 C-0.0571322892,1.0546002 -0.0811813567,0.576579296 0.184470821,0.261941397 C0.450122998,-0.0526965009 0.908306794,-0.0888638862 1.21643646,0.180481732 Z"></path></clipPath></defs><g transform="translate(-811.0 -2203.0)"><g clip-path="url(#515397118108106112118103116)"><g transform="translate(623.0 2193.0)"><g transform="translate(188.0 10.0)"><g clip-path="url(#501171015449121110480110)"><polygon points="1.11022302e-16,-5.55111512e-17 6.0000007,-5.55111512e-17 6.0000007,10 1.11022302e-16,10 1.11022302e-16,-5.55111512e-17" stroke="none" fill="#000000"></polygon></g></g></g></g></g></svg>',
    });

    $(".product__related-items a").on("mouseenter", function () {
        var color = $(this).data("color");
        $(".current-color").text(color);
    });

    $(".product__related-items a").on("mouseleave", function () {
        var color = $(".product__related-items .current a").data("color");
        $(".current-color").text(color);
    });

    // Filters change

    $(document).on("facet:criteria-changed", function () {
        setTimeout(function () {
            $(".product-grid__related-items").not(".slick-initialized").slick({
                infinite: true,
                slidesToShow: 3,
                slidesToScroll: 3,
                arrows: true,
                prevArrow:
                    '<svg class="slick-prev slick-arrow" version="1.1" width="6px" height="10px" viewBox="0 0 6.0 10.0" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><clipPath id="10711812254105122484848114"><path d="M1440,0 L1440,4163 L0,4163 L0,0 L1440,0 Z"></path></clipPath><clipPath id="10211211095104501019510698"><path d="M1.21643646,0.180481732 L5.68569211,4.27665462 C5.88526556,4.45959898 5.99974686,4.72306582 6,5 C6.00032762,5.27635063 5.88638723,5.53946082 5.68729572,5.72209247 L1.21643646,9.81951827 C0.908306794,10.0888639 0.450122998,10.0526965 0.184470821,9.7380586 C-0.0811813567,9.4234207 -0.0571322892,8.9453998 0.238636445,8.66141392 L4.14823289,5.07851555 C4.16994364,5.05869072 4.18239344,5.03007575 4.18239344,5 C4.18239344,4.96992425 4.16994364,4.94130928 4.14823289,4.92148445 L0.238636445,1.33858608 C-0.0571322892,1.0546002 -0.0811813567,0.576579296 0.184470821,0.261941397 C0.450122998,-0.0526965009 0.908306794,-0.0888638862 1.21643646,0.180481732 Z"></path></clipPath></defs><g transform="translate(-623.0 -2203.0)"><g clip-path="url(#10711812254105122484848114)"><g transform="translate(623.0 2193.0)"><g transform="translate(6.0 10.0) scale(-1.0 1.0)"><g clip-path="url(#10211211095104501019510698)"><polygon points="1.11022302e-16,-5.55111512e-17 6.0000007,-5.55111512e-17 6.0000007,10 1.11022302e-16,10 1.11022302e-16,-5.55111512e-17" stroke="none" fill="#000000"></polygon></g></g></g></g></g></svg>',
                nextArrow:
                    '<svg class="slick-next slick-arrow" version="1.1" width="6px" height="10px" viewBox="0 0 6.0 10.0" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><clipPath id="515397118108106112118103116"><path d="M1440,0 L1440,4163 L0,4163 L0,0 L1440,0 Z"></path></clipPath><clipPath id="501171015449121110480110"><path d="M1.21643646,0.180481732 L5.68569211,4.27665462 C5.88526556,4.45959898 5.99974686,4.72306582 6,5 C6.00032762,5.27635063 5.88638723,5.53946082 5.68729572,5.72209247 L1.21643646,9.81951827 C0.908306794,10.0888639 0.450122998,10.0526965 0.184470821,9.7380586 C-0.0811813567,9.4234207 -0.0571322892,8.9453998 0.238636445,8.66141392 L4.14823289,5.07851555 C4.16994364,5.05869072 4.18239344,5.03007575 4.18239344,5 C4.18239344,4.96992425 4.16994364,4.94130928 4.14823289,4.92148445 L0.238636445,1.33858608 C-0.0571322892,1.0546002 -0.0811813567,0.576579296 0.184470821,0.261941397 C0.450122998,-0.0526965009 0.908306794,-0.0888638862 1.21643646,0.180481732 Z"></path></clipPath></defs><g transform="translate(-811.0 -2203.0)"><g clip-path="url(#515397118108106112118103116)"><g transform="translate(623.0 2193.0)"><g transform="translate(188.0 10.0)"><g clip-path="url(#501171015449121110480110)"><polygon points="1.11022302e-16,-5.55111512e-17 6.0000007,-5.55111512e-17 6.0000007,10 1.11022302e-16,10 1.11022302e-16,-5.55111512e-17" stroke="none" fill="#000000"></polygon></g></g></g></g></g></svg>',
            });
        }, 2000);

        console.log("now");
    });

    // Read more accordion

    $(".button__read-more").on("click touch", function (e) {
        e.preventDefault();
        var button = $(this);
        var hiddenContent = $(this).closest(".section").find(".read-more");

        if ($(hiddenContent).is(":visible")) {
            hiddenContent.hide();
            button.find(".read-more-text").show();
            button.find(".read-less-text").hide();
        } else {
            hiddenContent.show();
            button.find(".read-less-text").show();
            button.find(".read-more-text").hide();
        }
    });
});

// Stories scroller

const scroller = document.querySelector(".link-bar__scroller");
const leftArrow = document.querySelector(".link-bar__arrow--left");
const rightArrow = document.querySelector(".link-bar__arrow--right");
const threshold = 5; // You can adjust this value as needed

// Function to update the arrow state
function updateArrowState() {
    if (scroller && leftArrow && rightArrow) {
        // Left arrow state
        leftArrow.disabled = scroller.scrollLeft <= 0;

        // Right arrow state with a threshold
        rightArrow.disabled =
            scroller.scrollLeft + scroller.offsetWidth >=
            scroller.scrollWidth - threshold;
    }
}

// Left arrow click event
if (leftArrow) {
    leftArrow.addEventListener("click", () => {
        if (!leftArrow.disabled && scroller) {
            scroller.scrollBy({
                left: -1000,
                behavior: "smooth",
            });
        }
    });
}

// Right arrow click event
if (rightArrow) {
    rightArrow.addEventListener("click", () => {
        if (!rightArrow.disabled && scroller) {
            scroller.scrollBy({
                left: 1000,
                behavior: "smooth",
            });
        }
    });
}

// Listen to the scroll event to update arrow state
if (scroller) {
    scroller.addEventListener("scroll", updateArrowState);
}

// Update arrow state right after the entire page is loaded and after a slight delay
window.addEventListener("load", () => {
    setTimeout(updateArrowState, 100); // 100ms delay
});
